import { useEffect, useReducer } from 'react'

import { mediaQueries, mediaQueriesList } from './constants'

const mediaQueriesLargestFirst = [...mediaQueriesList].reverse()

export const breakpoints = mediaQueriesLargestFirst.map(
  (breakpointName) => mediaQueries[breakpointName],
)

const createMediaMatcher = (query) =>
  typeof window === 'undefined' ? {} : window.matchMedia(query)

export const useScreenSize = () => {
  const breakpointMatchers = breakpoints.map(createMediaMatcher)

  const getCurrentBreakpoint = () => {
    const index = breakpointMatchers.findIndex((mql) => mql.matches)
    return mediaQueriesLargestFirst[index]
  }

  const [currentBreakpoint, setCurrentBreakpoint] = useReducer(
    getCurrentBreakpoint,
    getCurrentBreakpoint(),
  )

  useEffect(() => {
    breakpointMatchers.forEach((mql) => mql.addListener(setCurrentBreakpoint))

    return () => breakpointMatchers.forEach((mql) => mql.removeListener(setCurrentBreakpoint))
  }, [breakpointMatchers])

  return currentBreakpoint
}
